'use client'

import React from 'react'

import { TermsPage } from 'Components/Pages'

export default function TermsConditions() {
  return <TermsPage />
}
